document.addEventListener('DOMContentLoaded', () => {
    function disableEnterOnInput(input) {
        input.addEventListener('keypress', e => {
            if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
            }
        });
    }

    function init(el) {
        const email = el.querySelector('[data-iso-price-alarm-email]');
        const price = el.querySelector('[data-iso-price-alarm-price]');
        const submit = el.querySelector('[data-iso-price-alarm-submit]');
        const success = el.querySelector('[data-iso-price-alarm-success]');
        const error = el.querySelector('[data-iso-price-alarm-error]');

        if (!email || !price || !submit || !success || !error) {
            return;
        }

        const config = JSON.parse(el.dataset.isoPriceAlarm);

        // Disable the "Enter" key press on inputs
        disableEnterOnInput(email)
        disableEnterOnInput(price)

        submit.addEventListener('click', e => {
            e.preventDefault();

            el.classList.add('ajax-loading');
            error.innerHTML = '';
            success.innerHTML = '';
            email.disabled = true;
            price.disabled = true;
            submit.disabled = true;

            fetch(config.url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: `email=${email.value}&price=${price.value}`,
            })
                .then(response => {
                    response.text().then(text => {
                        if (response.status === 200) {
                            success.innerHTML = text;
                            email.value = '';
                            price.value = '';
                        } else {
                            error.innerHTML = text;
                        }
                    })
                })
                .finally(() => {
                    email.disabled = false;
                    price.disabled = false;
                    submit.disabled = false;
                    el.classList.remove('ajax-loading');
                })
            ;
        });
    }

    document.querySelectorAll('[data-iso-price-alarm]').forEach(init);
});
